export default function Card32Rules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                `}
            </style>

            <div class="modal fade show" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>32 Card Casino</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">
                                                The objective of 32 Card Casino is to predict the winning player of the game round. 32 Card Casino is played with a deck of 32 cards which does not include A,2,3,4,5 ranked cards.
                                                To win, you need to predict if total of the base value of the Player and cards dealt with the Player will be higher than other three Players. You can back or lay on any Player.
                                                On Draw between one or more Players, the market will be reopened for the next cards.
                                            </p>

                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20">When the game round starts, no cards are dealt but the market is opened for initial Betting. </p>
                                            <p class="pt20">After the market is suspended, each player is dealt one card.</p>
                                            <p class="pt20">
                                                If there is a tie between two players more cards will be dealt to the tied players.
                                                This will continue until the winner is decided.
                                            </p>
                                        </div>
                                    </center>

                                    <div>
                                        <div>
                                            <center><h3>Number Ranking:</h3></center>
                                            <div>
                                                <table class="table table-bordered table-sm">

                                                    <tbody>
                                                        <tr>
                                                            <th>6 </th>
                                                            <th>6  points</th>
                                                        </tr>
                                                        <tr>
                                                            <th>7 </th>
                                                            <th>7  points</th>
                                                        </tr>
                                                        <tr>
                                                            <th>8 </th>
                                                            <th>8  points</th>
                                                        </tr>
                                                        <tr>
                                                            <th>9 </th>
                                                            <th>9  points</th>
                                                        </tr>
                                                        <tr>
                                                            <th>10 </th>
                                                            <th>10  points</th>
                                                        </tr>

                                                        <tr>
                                                            <th>J </th>
                                                            <th>11  points</th>
                                                        </tr>
                                                        <tr>
                                                            <th>Q </th>
                                                            <th>12  points</th>
                                                        </tr>
                                                        <tr>
                                                            <th>K </th>
                                                            <th>13  points</th>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>

                                    </div>

                                    <div>
                                        <center><h3>Player Score Calculation</h3></center>
                                        <ol>
                                            <li class="lit20">Player 8: Have a base value of 8 which is added to card(s)' total value. </li>
                                            <li class="lit20">Player 9: Have a base value of 9 which is added to card(s)' total value.</li>

                                            <li class="lit20">Player 10: Have a base value of 10 which is added to card(s)' total value. </li>
                                            <li class="lit20">Player 11: Have a base value of 11 which is added to card(s)' total value.</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}